import { createContext } from 'react';

const SMHeaderContext = createContext({});

export default SMHeaderContext;
